// Settings and miscellaneous routes
import NotFound from '../../views/NotFound.vue'
import AddonsManager from '../../views/Addons.vue'
import AddonDetails from '../../views/AddonDetails.vue'
import TermsOfService from '../../views/Terms.vue'
import PrivacyPolicy from '../../views/Privacy.vue'
import Settings from '../../views/Settings.vue'
import SessionsList from '../../components/Sessions.vue'
import LocalizationSelector from '../../components/LocalizationSelector.vue'
import SubscriptionView from '../../views/SubscriptionView.vue'
import PaymentsView from '../../views/PaymentsView.vue'
import ComingSoon from '../../components/ComingSoon.vue'
import WalkthroughsView from '../../components/Walkthroughs.vue'

export default [
  {
    path: '/addons',
    name: 'Addons',
    component: AddonsManager,
    meta: { 
      requiresAuth: true,
      title: 'Add-ons'
    }
  },
  {
    path: '/addons/create',
    name: 'CreateAddon',
    component: AddonDetails,
    meta: { 
      requiresAuth: true,
      title: 'Create Add-on'
    }
  },
  {
    path: '/addons/:id',
    name: 'AddonDetails',
    component: AddonDetails,
    meta: { 
      requiresAuth: true,
      title: 'Add-on Details'
    }
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: TermsOfService,
    meta: { 
      requiresAuth: true,
      title: 'Terms of Service'
    }
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { 
      requiresAuth: true,
      title: 'Privacy Policy'
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { 
      requiresAuth: true,
      title: 'Settings'
    }
  },
  {
    path: '/sessions',
    name: 'Sessions',
    component: SessionsList,
    meta: { 
      requiresAuth: true,
      title: 'Sessions'
    }
  },
  {
    path: '/language-selector',
    name: 'LanguageSelector',
    component: LocalizationSelector,
    meta: { 
      requiresAuth: true,
      title: 'Language Settings'
    }
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: SubscriptionView,
    meta: { 
      requiresAuth: true,
      title: 'Subscriptions'
    }
  },
  {
    path: '/payments',
    name: 'Payments',
    component: PaymentsView,
    meta: { 
      requiresAuth: true,
      title: 'Payments'
    }
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ComingSoon,
    meta: { 
      requiresAuth: true,
      title: 'Coming Soon'
    }
  },
  {
    path: '/walkthroughs',
    name: 'Walkthroughs',
    component: WalkthroughsView,
    meta: { 
      requiresAuth: true,
      title: 'Walkthroughs'
    }
  },
  // Catch-all route for 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { requiresAuth: false, title: 'Page Not Found' }
  }
] 